export default __webpack_public_path__ + "51d7da6ad8972853beeeee7a5ac2948d.svg";